<template>
  <div class="line-item"> 
      <div class="heading ml-2" style="display:flex;" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">                   
        <v-btn class="missionbtn mx-0 pr-2"  flat>
          {{ missionGlobal.MIG_LIBELLE }} {{ $t("Simulation.Current") }} 
        </v-btn>        
        <v-btn class="mx-0" small icon @click.prevent="selectCurrentCoverage()"  :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon :class="{active:coverageState.selectedCoverageId == null}">mdi-crosshairs-gps</v-icon></v-btn>
      </div>           
  </div> 
</template>
<script lang="ts">

import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { AloDbMission } from '@/models/alodb/AloDbMission'
import Vue from 'vue'
import Component from 'vue-class-component'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'

@Component({
name: 'CoverageCurrentLine',  
props:{    
 
}
})
export default class CoverageCurrentLine extends Vue {      

    
  //le composant n'est utilisé que si une missionGlobal est sélectionnée
  get missionGlobal() {
    return this.$store.myGetters.originalAdmMissionGlobal
  }

  get coverage_uiid() {
    return buildCoverageStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get coverageState() { 
    //retourne un MapUiState    
    return this.$store.myGetters.coverageStateByUiid(this.coverage_uiid)
  }

  
  get map_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"map")
  }
  
  selectCurrentCoverage()  {
    if(this.$store.myGetters.modifiedAdmMissionGlobal.MIG_ID != null) {
      this.$store.state.ui.hideMap = true
      this.$nextTick(()=> {
        this.$store.myActions.MISSIONGLOBAL_CANCEL_MODIFIED_ADM()                  
        this.coverageState.selectedCoverageId = null   
        this.$nextTick(()=>this.$store.state.ui.hideMap = false)
        setTimeout(()=>  this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid),500)
      })
    }    
  }
}

</script> 

<style>

.rotate180{
  transform: rotate(-180deg);
}

.missionbtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.testMission{
  font-style: italic;
  color: rgb(128, 128, 128)!important;
}

.line-item{
  border-bottom: 1px solid #eee;
}
.line-item .active{
  color: #4caf50!important;  
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}

.missionbtn{
  flex:1 0 auto;
}

.missionbtn .v-btn__content{
  justify-content: flex-start;
}

</style>